import { useQuery } from '@tanstack/react-query';

import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

import { useCurrentUserId } from 'src/app/shared/hooks/session';

import { getStarterDashboardCommentsPetitionData } from '../../api/petitionData';

export function usePetitionData(slug: string) {
	const utilityContext = useUtilityContext();
	const userId = useCurrentUserId();

	return useQuery({
		queryKey: ['starter-dashboard-comments-data', slug, userId],
		queryFn: async () => getStarterDashboardCommentsPetitionData(utilityContext, slug, userId),
		staleTime: Infinity,
		refetchOnWindowFocus: false,
	});
}
